/**
 * Formas de desenhar os sensores de um transformador no painel.
 *
 * Ambas mostram um elemento por sensor, de tamanho igual: o donut é a barra
 * enrolada em círculo, e continua sendo possível contar quantos sensores há.
 */
export const panelCharts = {
  BAR: 'bar',
  DONUT: 'donut',
};

export const DEFAULT_PANEL_CHART = panelCharts.BAR;

export function isValidPanelChart(value) {
  return Object.keys(panelCharts).some(name => panelCharts[name] === value);
}

export default panelCharts;
